import { Component, OnInit } from '@angular/core';
import { Config } from 'src/app/models/env-vars.model';
import { alertService } from 'src/app/services/alert-service.service';
import { API } from 'src/app/services/api.service';
import { AppData } from 'src/app/services/appdata.service';
import { Global } from 'src/app/services/global.service';

@Component({
  selector: 'app-review',
  templateUrl: './admin-review.component.html',
  styleUrls: ['./admin-review.component.css']
})
export class AdminReviewComponent implements OnInit {

  constructor(
    private alertService: alertService,
    public appData: AppData,
    public global: Global,
    private api: API

  ) { }

  loader: boolean = false;
  downloading: boolean = false;
  review_data: any = [];
  leed_id: any = "";
  sorted_data: any = [];
  filtered_data: any = [];

  getReviewDataFromS3() {
    this.filtered_data = [];
    this.review_data = [];
    if (this.leed_id == "") {
      return false;
    }

    this.loader = true;

    this.api.get('/assets/LEED:' + this.leed_id + '/review/snapshot/keys/').subscribe(
      data => {
        this.loader = false;
        if (data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].document_metadata == null && data[i].doc_category == null && data[i].doc_description == null) {
              var name = data[i].doc_key.split('/')[1];
              if (data[i].doc_key.split('/')[1] != data[i].doc_key.split('/')[2]) {
                name = data[i].doc_key.split('/')[1] + ' (' + data[i].doc_key.split('/')[2] + ')';
              }
              var uploaded_at = data[i].uploaded_at;
              if (name.indexOf('LEED Certification') > -1) {
                this.loader = true;
                this.api.get('/assets/LEED:' + this.leed_id + '/certifications/registration/').subscribe(
                  data => {
                    if (data.length > 0) {
                      this.review_data.push({ "name": data[0].rating_system, "last_modified": uploaded_at })
                    }
                    else {
                      this.review_data.push({ "name": name, "last_modified": uploaded_at })
                    }
                    this.loader = false;
                    this.filtered_data = this.removeDuplicates(this.review_data, "name");
                  },
                  error => {
                    this.loader = false;
                    this.review_data.push({ "name": name, "last_modified": uploaded_at });
                    this.filtered_data = this.removeDuplicates(this.review_data, "name");
                  }
                );
              }
              else {
                this.review_data.push({ "name": name, "last_modified": uploaded_at })
              }
            }
          }
        }
        this.filtered_data = this.removeDuplicates(this.review_data, "name");
      },
      error => {
        this.loader = false;
      }
    );
  };

  removeDuplicates(originalArray: any, prop: any) {
    var newArray = [];
    var lookupObject: any = {};
    for (var i in originalArray) {
      lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (i in lookupObject) {
      newArray.push(lookupObject[i]);
    }
    return newArray;
  }

  downloadKey(data: any) {
    this.global.anchorDownload(data.name + ".zip", Config.basic_api_url + '/assets/LEED:' + this.leed_id + '/review/snapshot/?access-token=' + this.appData.get('token') + '&subscription-key=' + Config.sub_key);
  };

  ngOnInit(): void {
  }

}